import { api } from '.';

const csrfSessionName = 'csrf_token';
const setCSRFToken = (csrf_token: any) => {
  sessionStorage.setItem(csrfSessionName, JSON.stringify(csrf_token));
};

export const cleanCSRFToken = () => {
  sessionStorage.removeItem(csrfSessionName);
};

const getCSRFServerToken = async () => {
  const response = await api.get('/getCSRFToken');

  return response?.data;
};

export const getCSRFToken = async () => {
  let csrftoken = sessionStorage.getItem(csrfSessionName);

  if (!csrftoken) {
    setCSRFToken('true');
    const data = await getCSRFServerToken();
    csrftoken = data.csrf_token;
    setCSRFToken(csrftoken);
  }

  api.defaults.headers.common = {
    'X-CSRF-TOKEN': csrftoken,
  };

  return csrftoken;
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 400) {
      cleanCSRFToken();
    }
    return error;
  },
);
